import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-277d4786"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex justify-content-between gap-2" }
const _hoisted_2 = { class: "p-input-icon-left float-right" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "flex flex-column align-items-start gap-1" }

import { Patient } from '@/interfaces/Patient';
import { ref, PropType, toRaw, watch, computed } from 'vue';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import Tag from 'primevue/tag';
import { useRouter } from 'vue-router';
import { DateUtils } from '@/utils/DateUtils';
import { useToast } from 'primevue/usetoast';
import PatientsService from '@/services/PatientsService';

const REINVITE_COOLDOWN_DAYS = 7;


export default /*#__PURE__*/_defineComponent({
  __name: 'PatientList',
  props: {
  patients: {
    type: Array as PropType<Patient[]>,
    default: () => []
  }
},
  setup(__props) {

const props = __props;

const filteredPatients = ref<Patient[]>([...props.patients]);

const searchQuery = ref();
const router = useRouter();

const safeDisplay = (value: string): string => value || '';

const clearFilter = () => {
  searchQuery.value = '';
  filteredPatients.value = [...props.patients];
};

const searchData = () => {
  const query = searchQuery.value?.toLowerCase() || '';
  filteredPatients.value = props.patients.filter((wrapperPatient) => {
    const patient = toRaw(wrapperPatient);
    return (
      patient.phoneNo?.toLowerCase().includes(query) ||
      patient.firstName?.toLowerCase().includes(query) ||
      patient.lastName?.toLowerCase().includes(query) ||
      patient.email?.toLowerCase().includes(query) ||
      patient.diagnose?.toLowerCase().includes(query)
    );
  });
};

const setDefaultProfileImage = (patient: Patient) => {
  patient.photoUrl =
    'https://www.vhv.rs/dpng/d/256-2569650_men-profile-icon-png-image-free-download-searchpng.png';
};

const onSelectedRow = (event: any) => {
  if (event.data.status == 0) {
    //alert('Acest utilizator a fost sters');
  } else {
    const selectedPatientId = event.data.id;
    router.push({ name: 'patient-details', params: { id: selectedPatientId } });
  }
};

watch(
  () => props.patients,
  (newValue) => {
    console.log(newValue);
    filteredPatients.value = [...newValue];
    searchData();
  },
  { immediate: true }
);

const computedPatients = computed(() => {
  return filteredPatients.value.map(d => ({
    ...d,
    sortName: `${d.firstName ?? ''} ${d.lastName ?? ''}`.toLowerCase(),
    sortCreatedAt: d.createdAt ? new Date(d.createdAt).getTime() : 0
  }));
});

const toast = useToast();
const sending = ref<Record<string, boolean>>({});
const lastReminderAtOverrides = ref<Record<string, string>>({});

const lastReminderLabel = (data: { id: string; lastReminderAt?: string }) => {
  const date = lastReminderAtOverrides.value[data.id] || data.lastReminderAt;
  return date ? `Ultima trimitere: ${DateUtils.format(date)}` : undefined;
};

const handleReinvite = async (patient: Patient) => {
  const effectiveLastReminderAt = lastReminderAtOverrides.value[patient.id] || patient.lastReminderAt;
  if (effectiveLastReminderAt) {
    const daysSinceLast = DateUtils.daysBetween(effectiveLastReminderAt, new Date());
    if (daysSinceLast !== null && daysSinceLast < REINVITE_COOLDOWN_DAYS) {
      toast.add({
        severity: 'warn',
        summary: 'Atenție',
        detail: 'Invitația a mai fost trimisă în ultimele 7 zile',
        life: 4000
      });
      return;
    }
  }
  sending.value[patient.id] = true;
  try {
    const result = await PatientsService.sendActivationReminder(patient.id);
    lastReminderAtOverrides.value[patient.id] = result.lastReminderAt;
    toast.add({
      severity: 'success',
      summary: 'Succes',
      detail: 'Invitația a fost trimisă',
      life: 3000
    });
  } catch {
    toast.add({
      severity: 'error',
      summary: 'Eroare',
      detail: 'Invitația nu a putut fi trimisă',
      life: 4000
    });
  } finally {
    sending.value[patient.id] = false;
  }
};


return (_ctx: any,_cache: any) => {
  const _component_InputIcon = _resolveComponent("InputIcon")!
  const _component_IconField = _resolveComponent("IconField")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_unref(DataTable), {
    value: computedPatients.value,
    sortField: "sortCreatedAt",
    sortOrder: -1,
    onRowSelect: onSelectedRow,
    selectionMode: "single",
    stripedRows: "",
    paginator: "",
    rows: 5,
    rowsPerPageOptions: [5, 10, 20, 50]
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(Button), {
          type: "button",
          class: "p-button-sm",
          icon: "pi pi-filter-slash",
          outlined: "",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (clearFilter()))
        }),
        _createElementVNode("span", _hoisted_2, [
          _createVNode(_component_IconField, null, {
            default: _withCtx(() => [
              _createVNode(_component_InputIcon, { class: "pi pi-search" }),
              _createVNode(_unref(InputText), {
                class: "md:w-auto w-10rem",
                onInput: searchData,
                modelValue: searchQuery.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchQuery).value = $event)),
                placeholder: "Caută.."
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(Column), { header: "" }, {
        body: _withCtx(({ data }) => [
          _createVNode(_component_Avatar, {
            image: data.photoUrl,
            icon: data.photoUrl ? undefined : 'pi pi-user',
            shape: "circle",
            size: "normal"
          }, null, 8, ["image", "icon"])
        ]),
        _: 1
      }),
      _createVNode(_unref(Column), {
        header: "Nume",
        field: "sortName",
        sortable: "",
        style: {"width":"100px"}
      }, {
        body: _withCtx(({ data }) => [
          _createElementVNode("span", null, _toDisplayString(safeDisplay(data.firstName) + ' ' + safeDisplay(data.lastName)), 1)
        ]),
        _: 1
      }),
      _createVNode(_unref(Column), {
        field: "phoneNo",
        header: "Telefon"
      }),
      _createVNode(_unref(Column), {
        header: "Email",
        style: {"width":"100px"}
      }, {
        body: _withCtx(({ data }) => [
          _createTextVNode(_toDisplayString(data.email ? data.email : '-'), 1)
        ]),
        _: 1
      }),
      _createVNode(_unref(Column), {
        field: "diagnose",
        header: "Diagnostic",
        sortable: ""
      }),
      _createVNode(_unref(Column), {
        header: "Inregistrat",
        field: "sortCreatedAt",
        sortable: ""
      }, {
        body: _withCtx(({ data }) => [
          _createTextVNode(_toDisplayString(_unref(DateUtils).format(data.createdAt)), 1)
        ]),
        _: 1
      }),
      _createVNode(_unref(Column), { header: "Ultimul reminder" }, {
        body: _withCtx(({ data }) => [
          (data.reminderOptedOut)
            ? (_openBlock(), _createBlock(_unref(Tag), {
                key: 0,
                value: "Dezabonat",
                severity: "warning"
              }))
            : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString((lastReminderAtOverrides.value[data.id] || data.lastReminderAt) ? _unref(DateUtils).format(lastReminderAtOverrides.value[data.id] || data.lastReminderAt) : '-'), 1))
        ]),
        _: 1
      }),
      _createVNode(_unref(Column), { header: "Confirmat" }, {
        body: _withCtx(({ data }) => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(Tag), {
              severity: data.confirmed === true ? 'success' : 'danger',
              value: data.confirmed === true ? 'confirmat' : 'neconfirmat'
            }, null, 8, ["severity", "value"]),
            (!data.confirmed)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
                }, [
                  (!data.reminderOptedOut)
                    ? _withDirectives((_openBlock(), _createBlock(_unref(Button), {
                        key: 0,
                        label: "Reinvită",
                        icon: "pi pi-send",
                        size: "small",
                        class: "p-button-sm p-button-outlined reinvite-btn",
                        loading: sending.value[data.id],
                        onClick: ($event: any) => (handleReinvite(data))
                      }, null, 8, ["loading", "onClick"])), [
                        [
                          _directive_tooltip,
                          { value: lastReminderLabel(data), showDelay: 100 },
                          void 0,
                          { top: true }
                        ]
                      ])
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }),
      _createVNode(_unref(Column), { header: "Activ" }, {
        body: _withCtx(({ data }) => [
          _createElementVNode("span", null, [
            (data.status != 0)
              ? _withDirectives((_openBlock(), _createBlock(_unref(Tag), {
                  key: 0,
                  severity: data.status == 1 ? 'success' : 'warning',
                  icon: 
                data.status === true
                  ? 'pi pi-check-circle'
                  : 'pi pi-times-circle'
              ,
                  value: data.status == 1 ? 'Da' : 'Nu'
                }, null, 8, ["severity", "icon", "value"])), [
                  [
                    _directive_tooltip,
                    {
                value: data.status == 1 ? 'Cont activ' : 'Cont suspendat',
                showDelay: 100,
                hideDelay: 300
              },
                    void 0,
                    { left: true }
                  ]
                ])
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["value"]))
}
}

})